import { css } from 'linaria';
import { breakpoints } from 'common/styles/breakpoints';

export const wrapper = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-100);
  padding: var(--space-225) var(--space-200);
  color: var(--text-primary);
  background-color: var(--attention-light);
  border-radius: var(--rounding-l);
  ${breakpoints.to.tablet} {
    width: 100%;
  }
`;

export const withHint = css`
  padding: var(--space-225) var(--space-150) var(--space-225) var(--space-200);
`;

export const icon = css`
  display: flex;
`;

export const modal = css`
  --gapBetweenModals: 0;
`;
